
import Vue from 'vue'
import map from './vue/mapa.vue'
import { i18n } from './i18n.js'

window.axios = require('axios');
window.Vue = Vue
window.i18n = i18n

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.component('map-component', map);



// WEBPACK FOOTER //
// ./scripts/vuecomponents.js